import React, { useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";

const COUNTRIES = [
  { name: "India", code: "in", route: "/immigration/India", region: "Asia" },
  {
    name: "USA",
    code: "us",
    route: "/immigration/usa",
    region: "North America",
  },
  { name: "Japan", code: "jp", route: "/immigration/japan", region: "Asia" },
  {
    name: "Australia",
    code: "au",
    route: "/immigration/australia",
    region: "Oceania",
  },
  {
    name: "United Kingdom",
    code: "gb",
    route: "/immigration/uk",
    region: "Europe",
  },
  {
    name: "Canada",
    code: "ca",
    route: "/immigration/canada",
    region: "North America",
  },
  {
    name: "Germany",
    code: "de",
    route: "/immigration/germany",
    region: "Europe",
  },
  {
    name: "Sweden",
    code: "se",
    route: "/immigration/sweden",
    region: "Europe",
  },
  {
    name: "New Zealand",
    code: "nz",
    route: "/immigration/NewZealand",
    region: "Oceania",
  },
  {
    name: "Netherlands",
    code: "nl",
    route: "/immigration/Netherlands",
    region: "Europe",
  },
  {
    name: "Switzerland",
    code: "ch",
    route: "/immigration/Switzerland",
    region: "Europe",
  },
  {
    name: "South Africa",
    code: "za",
    route: "/immigration/south-africa",
    region: "Africa",
  },
  {
    name: "Thailand",
    code: "th",
    route: "/immigration/thailand",
    region: "Asia",
  },
  {
    name: "South Korea",
    code: "kr",
    route: "/immigration/south-korea",
    region: "Asia",
  },
];

const REGIONS = ["All", ...Array.from(new Set(COUNTRIES.map((c) => c.region)))];

const CountryCard = ({ country }) => (
  <NavLink to={country.route} className="text-decoration-none">
    <div className="country-card">
      <img
        src={`https://flagcdn.com/w80/${country.code}.png`}
        srcSet={`https://flagcdn.com/w160/${country.code}.png 2x`}
        alt={`${country.name} flag`}
        className="country-flag"
      />
      <h6 className="country-name">{country.name}</h6>
    </div>
  </NavLink>
);

const ImmCountry = () => {
  const [activeRegion, setActiveRegion] = useState("All");

  const filtered =
    activeRegion === "All"
      ? COUNTRIES
      : COUNTRIES.filter((c) => c.region === activeRegion);

  return (
    <div className="imm-country-container">
      <Container fluid className="px-4 py-4">
        <Row>
          <Col xs={12} className="mb-3">
            <h4 className="section-title">Immigration Policies by Country</h4>
          </Col>
        </Row>

        {/* Region Filter Tabs */}
        <Row>
          <Col xs={12} className="mb-4">
            <div className="region-tabs">
              {REGIONS.map((region) => (
                <button
                  key={region}
                  className={`region-tab ${
                    activeRegion === region ? "active" : ""
                  }`}
                  onClick={() => setActiveRegion(region)}
                >
                  {region}
                </button>
              ))}
            </div>
          </Col>
        </Row>

        <Row>
          {/* Countries Grid */}
          <Col lg={9} md={8} xs={12}>
            {filtered.length > 0 ? (
              <div className="immigration-grid">
                {filtered.map((country, index) => (
                  <CountryCard key={index} country={country} />
                ))}
              </div>
            ) : (
              <p className="text-muted">No countries found for this region.</p>
            )}
          </Col>

          {/* Sidebar */}
          <Col lg={3} md={4}>
            <div className="d-flex justify-content-center mb-2">
              <small className="text-muted">Advertisement</small>
            </div>
            <Link to="https://forms.gle/YZ8rr4Dzpwi4R3An7">
              <Image
                className="mx-auto d-block"
                src="https://ayg.s3.us-east-2.amazonaws.com/bharat/Beige+and+Brown+Illustrative+Krishna+Janmashtami+Greeting+Instagram+Post+(1).gif"
                fluid
              />
            </Link>
          </Col>
        </Row>
      </Container>

      <style jsx>{`
        .imm-country-container {
          background: #f8f9fa;
          min-height: 90vh;
        }

        .section-title {
          font-size: 1.75rem;
          font-weight: 700;
          color: #2c3e50;
          border-bottom: 3px solid #3498db;
          padding-bottom: 12px;
          margin-bottom: 0;
        }

        /* Region Filter Tabs */
        .region-tabs {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .region-tab {
          padding: 6px 16px;
          border-radius: 20px;
          border: 1.5px solid #d0d0d0;
          background: white;
          color: #555;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .region-tab:hover {
          border-color: #3498db;
          color: #3498db;
        }

        .region-tab.active {
          background: #3498db;
          border-color: #3498db;
          color: white;
        }

        /* Countries Grid */
        .immigration-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 12px;
        }

        .country-card {
          background: white;
          border-radius: 10px;
          padding: 15px 10px;
          text-align: center;
          transition: all 0.3s ease;
          cursor: pointer;
          border: 1px solid #e8e8e8;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        }

        .country-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 16px rgba(52, 152, 219, 0.2);
          border-color: #3498db;
        }

        .country-flag {
          width: 64px;
          height: 43px;
          object-fit: cover;
          border-radius: 5px;
          margin-bottom: 10px;
          border: 1px solid #e0e0e0;
          display: block;
          margin-left: auto;
          margin-right: auto;
        }

        .country-name {
          font-size: 13px;
          font-weight: 600;
          color: #2c3e50;
          margin: 0;
          line-height: 1.3;
        }

        /* Responsive */
        @media (max-width: 1200px) {
          .immigration-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }

        @media (max-width: 768px) {
          .immigration-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .section-title {
            font-size: 1.4rem;
          }
        }

        @media (max-width: 576px) {
          .immigration-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
      `}</style>
    </div>
  );
};

export default ImmCountry;
